// extracted by mini-css-extract-plugin
export default {"root":"Dpu4k","hidden":"RE1uY"};